import * as THREE from 'three';

/**
 * CG の家具を画面のクリック位置から拾う。
 *
 * buildHouse.js が家具ひとつひとつに userData.furniture を付けているので、
 * 当たった面から親をたどって、その家具のグループを返す。
 * 家具を消す機能（furnitureRemover.js）と値段の表示（ui/priceTags.js）が使う。
 */
export function createFurniturePicker({ root, camera, canvas }) {
  /** 家具の部品。index → グループ */
  const items = new Map();
  root.traverse((node) => {
    const info = node.userData?.furniture;
    if (info) items.set(info.index, node);
  });

  const raycaster = new THREE.Raycaster();
  const pointer = new THREE.Vector2();

  return {
    items,
    /** クリック位置にある家具のグループ。無ければ null */
    pick(event) {
      const rect = canvas.getBoundingClientRect();
      pointer.x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
      pointer.y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
      raycaster.setFromCamera(pointer, camera);
      const visible = [...items.values()].filter((node) => node.visible);
      for (const hit of raycaster.intersectObjects(visible, true)) {
        for (let node = hit.object; node !== null; node = node.parent) {
          if (node.userData?.furniture) return node;
        }
      }
      return null;
    },
  };
}
